<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

// import Stat from "@/components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
      // Stat,
   },
   data() { 
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
            },        
         ],
      
         isLoading: false,

         pieChart: {
            series: [],
            chartOptions: {
               labels: ["Completed", "Upcoming", "Cancelled", "No Show"],
               colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1"],
               legend: {
                  show: true,
                  position: 'bottom',
                  horizontalAlign: 'center',
                  verticalAlign: 'middle',
                  floating: false,
                  fontSize: '14px',
                  offsetX: 0
               },
               responsive: [{
                  breakpoint: 600,
                  options: {
                     chart: {
                        height: 240
                     },
                     legend: {
                        show: false
                     },
                  }
               }]
            }
         }, // pieChart ends


         todays_consultations: "",
         this_week_consultations: "",
         this_month_consultations: "",
         total_consultations: "",

         todays_users: "",
         this_week_users: "",
         this_month_users: "",
         total_users: "",

         today_earnings:0,
         this_week_earnings:0,
         this_month_earnings:0,
         total_earnings:0,

         todays_doctors: "",
         this_week_doctors: "",
         this_month_doctors: "",
         total_doctors: "",

         completed_consulations: "",
         pending_consulations: "",
         cancelled_consulations: "",
         noshow_consulations: "",
         doctors: [],
         patients: [],

         completed_consulations_month: [],


         splineAreaChart: {
            series: [{
               name: 'Consultations',
               data: []
            }],
            chartOptions: {
               chart: {
                  toolbar: {
                     show: false
                  }
               },
               dataLabels: {
                  enabled: false
               },
               stroke: {
                  curve: 'smooth',
                  width: 3,
               },
               colors: ['#34c38f'],
               xaxis: {
                  type: 'month',
                  categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
               },
               grid: {
                  borderColor: '#f1f1f1',
               },
               tooltip: {
                  x: {
                     format: 'dd/MM/yy HH:mm'
                  },
               }
            }
         }

      };
   },
   mounted() {},
   created(){
      this.fetchDashboard();
   },
   methods: {
      fetchDashboard(){

         let url = "clinic/dashboard";
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               //console.log(responseData);
               this.todays_consultations = responseData.todays_consultations;
               this.this_week_consultations = responseData.this_week_consultations;
               this.this_month_consultations = responseData.this_month_consultations;
               this.total_consultations = responseData.total_consultations;


               this.todays_users = responseData.todays_users;
               this.this_week_users = responseData.this_week_users;
               this.this_month_users = responseData.this_month_users;
               this.total_users = responseData.total_users;


               this.todays_doctors = responseData.todays_doctors;
               this.this_week_doctors = responseData.this_week_doctors;
               this.this_month_doctors = responseData.this_month_doctors;
               this.total_doctors = responseData.total_doctors;

               this.today_earnings = responseData.today_earnings;
               this.this_week_earnings = responseData.this_week_earnings;
               this.this_month_earnings = responseData.this_month_earnings;
               this.total_earnings = responseData.total_earnings;

               this.doctors = responseData.doctors;
               this.consultations = responseData.consultations;  

               this.completed_consulations = responseData.completed_consulations;
               this.pending_consulations = responseData.pending_consulations;
               this.cancelled_consulations = responseData.cancelled_consulations;
               this.noshow_consulations = responseData.noshow_consulations;
					this.pieChart.series = [this.completed_consulations, this.pending_consulations, this.cancelled_consulations, this.noshow_consulations];


               this.completed_consulations_month = responseData.completed_consulations_month;
               this.splineAreaChart.series = [{
					name: 'Consultations',
					data: this.completed_consulations_month
					}];

        
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));


      },


      getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic = JSON.parse(localStorage.getItem('medicino_clinic'));
               if (medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }

            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
      },
   }
};
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <!-- <div class="row mb-4">
         
         <div class="col-md-4">
            <Stat icon="fas fa-user-md" title="Active Doctors" value="50" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-procedures" title="Consulted Patients" value="50" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-notes-medical" title="Today's Consultations" value="50" />
         </div>  -->

         <!-- <div class="col-md-4">
            <Stat icon="fas fa-laptop-medical" title="Today's Online Consultations" value="50" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-hospital-user" title="Today's Offline Consultations" value="50" />
         </div>  -->

         <!-- <div class="col-md-4">
            <Stat icon="fas fa-credit-card" title="Today's Online Earnings" value="25" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-money-bill-alt" title="Today's Offline Earnings" value="25" />
         </div>  -->

         <!-- <div class="col-md-4">
            <Stat icon="fas fa-hand-holding-usd" title="Today's  Earnings" value="50" />
         </div>     

      </div> -->

      <div class="col-lg-12">
         <div class="row">
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Consultations</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-calendar-plus font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ todays_consultations }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ this_week_consultations }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ this_month_consultations }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ total_consultations }}</h4>
                                 </span>
                                 </div>
                              </div>
                           </div>
                        </div>
            </div>
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Users</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-procedures font-size-20"></i>                                 
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ todays_users }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ this_week_users }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ this_month_users }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ total_users }}</h4>
                                 </span>
                                 </div>
                              </div>
                           </div>
                        </div>
            </div>

            <div class="col-md-3">
                     <div class="card mini-stats-wid">
                        <div class="card-body">
                           <div class="media mb-3">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2 font-size-18">Doctors</p>
                              </div>

                              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                              <span class="avatar-title">
                                 <i class="fas fa-user-md font-size-20"></i>                              
                              </span>
                              </div>
                           </div>

                           <div class="media mb-2">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">Today</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ todays_doctors }}</h4>
                              </span>
                              </div>
                           </div>

                           <div class="media mb-2">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">This week</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ this_week_doctors }}</h4>
                              </span>
                              </div>
                           </div>

                           <div class="media mb-2">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">This month</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ this_month_doctors }}</h4>
                              </span>
                              </div>
                           </div>

                           <div class="media">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">Total</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ total_doctors }}</h4>
                              </span>
                              </div>
                           </div>
                        </div>
                     </div>
            </div>

            <div class="col-md-3">
                     <div class="card mini-stats-wid">
                        <div class="card-body">
                           <div class="media mb-3">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2 font-size-18">Earnings</p>
                              </div>

                              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                              <span class="avatar-title">
                                 <i class="fas fa-user-md font-size-20"></i>                              
                              </span>
                              </div>
                           </div>

                           <div class="media mb-2">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">Today</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ today_earnings }}</h4>
                              </span>
                              </div>
                           </div>

                           <div class="media mb-2">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">This week</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ this_week_earnings }}</h4>
                              </span>
                              </div>
                           </div>

                           <div class="media mb-2">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">This month</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ this_month_earnings }}</h4>
                              </span>
                              </div>
                           </div>

                           <div class="media">
                              <div class="media-body">
                              <p class="text-muted fw-medium mb-2">Total</p>
                              </div>

                              <div class="align-self-center ">
                              <span class="float-end me-3">
                                 <h4 class="mb-0 font-size-16">{{ total_earnings }}</h4>
                              </span>
                              </div>
                           </div>
                        </div>
                     </div>
            </div>
         </div>
      </div>


      
      <!-- end row -->

      <div class="row mb-5">
         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Consultations</h4>
                  <apexchart
                    class="apex-charts"
                    height="320"
                    type="pie"
                    dir="ltr"
                    :series="pieChart.series"
                    :options="pieChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>


         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Monthly Consultations</h4>
                  <apexchart
                    class="apex-charts"
                    height="350"
                    type="area"
                    dir="ltr"
                    :series="splineAreaChart.series"
                    :options="splineAreaChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->


      <div class="row">

         <div class="col-md-6">
            <div class="card">

               <div class="card-header bg-light p-3 d-flex justify-content-between">
                  <div class="header-title">
                     <h6 class="card-title">Doctors</h6>
                  </div>
                  <div class="card-header-toolbar d-flex align-items-center">
                     <router-link :to="{ name: 'doctors' }" class="btn btn-sm btn-outline-primary view-more">View all</router-link>
                  </div>
               </div>

               <div class="card-body">                  
                  <ul class="list-inline p-0 m-0">
                     <router-link :to="{ name: 'doctors.details', params: {id: doctor.id} }" v-for="(doctor) in doctors" :key="doctor.id">
                        <li class="media align-items-center mb-3">
                           <img v-if="doctor.image" :src="$image_url + doctor.image" alt="image" class="avatar-sm rounded-circle" />
                           <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle" alt="image" />
                           <div class="media-body ms-3">
                              <h6 class="mb-0 font-size-14"><span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}}</h6>
                              <p class="mb-0 text-primary">{{doctor.country_code}} {{doctor.mobile}}</p>
                              <p class="mb-0">{{doctor.created_at | formatDateTime}}</p>
                           </div>
                        </li>
                     </router-link>
                  </ul>
               </div>
            </div>
            <!-- end card -->
         </div>

         <!-- <div class="col-md-4"> -->
            <!-- <div class="card">

               <div class="card-header bg-light p-3 d-flex justify-content-between">
                  <div class="header-title">
                     <h6 class="card-title">Patients</h6>
                  </div>
                  <div class="card-header-toolbar d-flex align-items-center">
                     <router-link :to="{ name: 'patients' }" class="btn btn-sm btn-outline-primary view-more">View all</router-link>
                  </div>
               </div>

               <div class="card-body">                  
                  <ul class="list-inline p-0 m-0">
                     <li class="media align-items-center mb-3">
                        <img src="@/assets/images/users/avatar-5.jpg" class="avatar-sm rounded-circle" alt="image" />
                        <div class="media-body ms-3">
                           <h6 class="mb-0 font-size-14">Liz James</h6>
                           <p class="mb-0 text-primary">+91 8714501277</p>
                           <p class="mb-0">21 Oct 2021, 08:43 pm</p>
                        </div>
                     </li>

                     <li class="media align-items-center mb-3">
                        <img src="@/assets/images/users/avatar-5.jpg" class="avatar-sm rounded-circle" alt="image" />
                        <div class="media-body ms-3">
                           <h6 class="mb-0 font-size-14">Liz James</h6>
                           <p class="mb-0 text-primary">+91 8714501277</p>
                           <p class="mb-0">21 Oct 2021, 08:43 pm</p>
                        </div>
                     </li>

                     <li class="media align-items-center mb-3">
                        <img src="@/assets/images/users/avatar-5.jpg" class="avatar-sm rounded-circle" alt="image" />
                        <div class="media-body ms-3">
                           <h6 class="mb-0 font-size-14">Liz James</h6>
                           <p class="mb-0 text-primary">+91 8714501277</p>
                           <p class="mb-0">21 Oct 2021, 08:43 pm</p>
                        </div>
                     </li>

                     <li class="media align-items-center mb-3">
                        <img src="@/assets/images/users/avatar-5.jpg" class="avatar-sm rounded-circle" alt="image" />
                        <div class="media-body ms-3">
                           <h6 class="mb-0 font-size-14">Liz James</h6>
                           <p class="mb-0 text-primary">+91 8714501277</p>
                           <p class="mb-0">21 Oct 2021, 08:43 pm</p>
                        </div>
                     </li>

                     <li class="media align-items-center mb-3">
                        <img src="@/assets/images/users/avatar-5.jpg" class="avatar-sm rounded-circle" alt="image" />
                        <div class="media-body ms-3">
                           <h6 class="mb-0 font-size-14">Liz James</h6>
                           <p class="mb-0 text-primary">+91 8714501277</p>
                           <p class="mb-0">21 Oct 2021, 08:43 pm</p>
                        </div>
                     </li>

                     
                  </ul>
               </div>
            </div> -->
            <!-- end card -->
         <!-- </div> -->

         <div class="col-md-6">
            <div class="card">

               <div class="card-header bg-light p-3 d-flex justify-content-between">
                  <div class="header-title">
                     <h6 class="card-title">Consultations</h6>
                  </div>
                  <div class="card-header-toolbar d-flex align-items-center">
                     <router-link :to="{ name: 'consultations' }" class="btn btn-sm btn-outline-primary view-more">View all</router-link>
                  </div>
               </div>

               <div class="card-body">                  
                  <ul class="list-inline p-0 m-0">
                     <router-link :to="{ name: 'consultations.details', params: {id: consultation.booking_id} }" v-for="(consultation) in consultations" :key="consultation.booking_id">
                        <li class="media align-items-center mb-3">
                           <img v-if="consultation.image" :src="$image_url + consultation.image" alt="image"  class="avatar-sm rounded-circle"/>
                           <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle" alt="image" />
                           <div class="media-body ms-3">
                              <h6 class="mb-0 font-size-14"><span v-if="consultation.name">{{consultation.name}}</span><span v-else>Guest</span></h6>
                              <p class="mb-0 text-primary">{{consultation.country_code}} {{consultation.mobile}}</p>
                              <p class="mb-0">{{consultation.booking_date | formatDate}}, {{consultation.consultation_start | formatTime}}</p>
                           </div>
                        </li>
                     </router-link>
                  </ul>
               </div>
            </div>
            <!-- end card -->
         </div>
      </div>
      <!-- end row -->

    
   </Layout>
</template>
